import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FeedbackState, feedbackFeatureKey } from './feedback.reducer';

export const selectFeedbackState = createFeatureSelector<FeedbackState>(feedbackFeatureKey);

export const selectFeedbackSettings = createSelector(selectFeedbackState, (state) => state.feedbackSettings);

export const selectIsLoading = createSelector(selectFeedbackState, (state) => state.isLoading);
